<div class="barra-iconos-acciones">
  <app-icono-superior [icono]="'icon-excel-empty'" [isGrey]="true" [id]="'Excel'" (clickIcon)="botonAccionClicked($event)"></app-icono-superior>
  <app-icono-superior [icono]="'icon-pdf-empty'" [isGrey]="true" [id]="'Pdf'" (clickIcon)="botonAccionClicked($event)"></app-icono-superior>
</div>
